'use strict';

angular.module('amexReconciliationApp')
  .component('receiptDetailsModal', {
    templateUrl: 'scripts/views/components/receipt-details-modal.html',
    bindings: {
      receipts: '<',
      uploadFailure: '<',
      uploadSuccess: '<',
      currentBillingCycle: '<',
      closeModalCallback: '&',
      refreshReceipts: '='
    },
    controller: function (ReceiptRepository, toastr, dateFormats, UserModel, ReceiptService) {
      var self = this;

      self.$onInit = function() {
        self.receiptDetail = {};
        self.isUploading = false;
        self.closeModal = self.closeModalCallback;
        self.isDatePickerShowing = false;
        self.userDateFormat = dateFormats[(UserModel.currentUser().preferredDateFormat)];
        self.isReceiptViewableByName = ReceiptService.isReceiptViewableByName;
        self.today = new Date();
      };

      self.toggleDatePicker = function () {
        self.isDatePickerShowing = !self.isDatePickerShowing;
      };

      self.upload = function () {
        self.isUploading = true;
        self.receiptDetail.date = self.receiptDetail.date ? formatDate(self.receiptDetail.date) : undefined;
        ReceiptRepository.upload(createReceiptObjects(), self.currentBillingCycle)
          .then(function () {
            toastr.success(self.uploadSuccess);
            self.closeModal();
          }).catch(function (error) {
            toastr.error(error || self.uploadFailure);
          }).finally(function () {
            self.isUploading = false;
            if (self.refreshReceipts) {
              self.refreshReceipts();
            }
          });
      };

      function formatDate(date) {
        var d = date.getDate();
        var m = date.getMonth() + 1;
        var y = date.getFullYear();
        return y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
      }

      function createReceiptObjects() {
        var receiptObjects = [];
        _.forEach(self.receipts, function (receipt) {
          receiptObjects.push({
            file: receipt,
            details: self.receiptDetail
          });
        });

        return receiptObjects;
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/receiptDetailsModal.js
// module id = 473
// module chunks = 0